<template>
  <div>
    <div
      :id="'carrier-cost' + tripNumber"
      class="carrier-cost text-left"
      :key="routeKey"
    >
      <div class="carrier-cost__header">
        <h6 class="carrier-cost__header--title"><b>Carrier Cost</b></h6>
        <div class="carrier-cost__calculate-function">
          <b-form-select
            class="carrier-cost__calculate-function--equipment-type"
            v-model="selectedEquipmentType"
            :options="equipmentsType"
          ></b-form-select>
          <b-overlay
            :show="busy"
            rounded
            opacity="0.6"
            spinner-small
            class="d-inline-block"
            @hidden="onHidden"
          >
            <b-button
              v-if="allowed"
              ref="button-calculate"
              class="carrier-cost__calculate-function--calculate-button"
              size="sm"
              :disabled="busy || disableCalculate"
              @click="calculateRoute"
              ><i class="fa fa-calculator mr-1"></i> Calculate</b-button
            >
          </b-overlay>
        </div>
      </div>
      <hr />

      <div v-if="isHHModes" class="carrier-cost__elements">
        <span class="carrier-cost__elements--data"
          ><b>TS Paid: </b
          ><span v-if="routeCalculated != null">{{
            routeCalculated.truckStop_paid
          }}</span></span
        >
        <span class="carrier-cost__elements--data"
          ><b>TS Posted: </b
          ><span v-if="routeCalculated != null">{{
            routeCalculated.truckStop_posted
          }}</span></span
        >
      </div>
      <hr />
      <div class="carrier-cost__predicted">
        <div
          v-if="predictedCost && !predictedCost.message"
          class="mt-1 ml-2 carrier-cost__content carrier-cost__content"
        >
          <div>
            <h6 class="mb-4">
              <b class="border-bottom border-dark">{{ title1 }}</b>
            </h6>
            <div>
              <p class="carrier-cost__content"><b>Sale Price</b></p>
              <h1>${{ salePrice }}</h1>
              <p class="carrier-cost__content--text">
                <b>Target Confidence Level {{ confidenceLevel }}</b>
              </p>
            </div>
          </div>
          <div class="d-flex align-items-center mt-2">
            <div>
              <p class="m-0"><b>Predicted Cost:</b> {{ predictedCost }}</p>
              <p class="m-0"><b>Network Rate:</b> {{ networkRate }}</p>
              <p class="carrier-cost__content--text">Min: ${{ minPricing }}</p>
              <p class="carrier-cost__content--text">Max: ${{ maxPricing }}</p>
            </div>
          </div>
        </div>
        <div
          v-if="predictedCost2"
          class="mt-1 ml-2 carrier-cost__content carrier-cost__content--splitter"
        >
          <div>
            <h6 class="mb-4">
              <b class="border-bottom border-dark">{{ title2 }}</b>
            </h6>
            <div>
              <p class="carrier-cost__content"><b>Sale Price</b></p>
              <h1>${{ salePrice2 }}</h1>
              <p class="carrier-cost__content--text">
                <b>Target Confidence Level {{ confidenceLevel2 }}</b>
              </p>
            </div>
          </div>
          <div class="d-flex align-items-center mt-2">
            <div>
              <p class="m-0"><b>Predicted Cost:</b> {{ predictedCost2 }}</p>
              <p class="m-0"><b>Network Rate:</b> {{ networkRate2 }}</p>
              <p class="carrier-cost__content--text">Min: ${{ minPricing2 }}</p>
              <p class="carrier-cost__content--text">Max: ${{ maxPricing2 }}</p>
            </div>
          </div>
        </div>
      </div>
      <b-alert show variant="warning" v-if="showAlert" class="mt-1"
        >{{ predictedMsg }}.</b-alert
      >
    </div>
    <div>
      <div class="show-dat">
        <b-overlay
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          class="d-inline-block"
          @hidden="onHidden"
        >
          <b-button
            class="show-dat__button"
            v-b-toggle.collapse-1-inner
            size="sm"
            v-if="itemsTable"
            ><span
              ><b-icon icon="caret-down"></b-icon> Show DAT Table</span
            ></b-button
          >
        </b-overlay>
      </div>

      <b-collapse id="collapse-1-inner" class="mb-2" :visible="visibleTable">
        <div class="carrier-cost__table" v-if="itemsTable">
          <hr />
          <h5 class="carrier-cost__table--title"><b>DAT Broker Spot</b></h5>
          <b-table striped hover responsive :items="itemsTable"> </b-table>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { errorAlert } from "@/api/errorMessages";
import { missingFieldsAlert } from "@/api/errorMessages";
import { mapGetters } from "vuex";
import pricingEnabledUsers from "@/utils/OTR/pricingEnabledUsers";
import modesByDepartment from "../../../utils/OTR/modesByDepartment";

export default {
  name: "CarrierCost",
  props: {
    tripNumber: Number,
    disableCalculate: Boolean
  },
  data() {
    return {
      routeCalculated: null,
      routeKey: 0,
      busy: false,
      user: null,
      oldValueAux: null,
      allowed: true,
      itemsTable: null,
      infoHaul: null,
      visibleTable: true,
      missingInfo: null,
      item: null,
      assignedUser: null,
      selectedEquipmentType: null,
      equipmentsType: [
        { value: null, text: "Please, select an Equipment Type" },
        { value: "VAN", text: "VAN" },
        { value: "REEFER", text: "REEFER" },
        { value: "FLATBED", text: "FLATBED" }
      ],
      currentDepartment: null,
      predictedCost: undefined,
      minPricing: undefined,
      maxPricing: undefined,
      confidenceLevel: undefined,
      salePrice: undefined,
      networkRate: undefined,
      predictedCost2: undefined,
      minPricing2: undefined,
      maxPricing2: undefined,
      confidenceLevel2: undefined,
      salePrice2: undefined,
      networkRate2: undefined,
      showPredictedCost: "carrier-cost__elements--cost-data",
      showAlert: false,
      predictedMsg: "",
      actualQueue: null,
      title1: null,
      title2: null,
      isHHModes: false
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("quotes/quote", ["showInfoTablePricing"]),
    ...mapGetters("quotes/quote", ["showInfoMinPricing"]),
    ...mapGetters("quotes/quote", ["showInfoMaxPricing"])
  },
  watch: {
    async showInfoDepartment(value) {
      this.currentDepartment = value;
    },
    predictedCost() {
      this.filterPricingUser();
      this.activePricingAlert();
    },

    showInfoTablePricing() {
      this.predictedCost = this.showInfoTablePricing;
      this.filterPricingUser();
      this.activePricingAlert();
    },
    showInfoMinPricing() {
      this.minPricing = this.showInfoMinPricing;
    },
    showInfoMaxPricing() {
      this.maxPricing = this.showInfoMaxPricing;
    }
  },
  async created() {
    this.actualQueue = localStorage.getItem("actual-queue");
    this.filterPricingUser();
    this.unwatch = this.$store.watch(
      (state, getters) => getters["quotes/quote/showQuoteById"],
      (newValue, oldValue) => {
        this.oldValueAux = oldValue;
        if (
          this.$store.getters["quotes/quote/showQuoteById"].haul[
            this.tripNumber - 1
          ]
        ) {
          this.routeCalculated = this.$store.getters[
            "quotes/quote/showQuoteById"
          ].haul[this.tripNumber - 1].rate_iq;
        }
      }
    );
    this.infoHaul = this.$store.getters["quotes/quote/showQuoteById"].haul[
      this.tripNumber - 1
    ];
    if (this.infoHaul.rate_iq) {
      this.routeCalculated = this.infoHaul.rate_iq;
    }
    if (this.infoHaul.dat) {
      this.itemsTable = this.getTableDat(this.infoHaul.dat.data);
    }
    this.isHHModes = modesByDepartment?.HHModes.includes(
      this.infoHaul?.tms_mode?.name ||
        this.infoHaul?.tms_mode?.name === "FTL - Dry Team Drivers"
    );
    await this.getInfoPricingModel();
    await this.getSpecialServiceData();
  },
  mounted() {
    this.currentDepartment = this.showInfoDepartment;
    this.handlerCarrierCost();
    this.routeKey += 1;
  },
  methods: {
    async calculateRoute() {
      this.visibleTable = false;
      this.busy = true;
      if (this.selectedEquipmentType != null) {
        let quoteId = this.$route.params.id;
        let responseInfoHaul = await this.$store.dispatch(
          "quotes/quote/getQuote",
          quoteId
        );
        this.infoHaul = this.$store.getters["quotes/quote/showQuoteById"].haul[
          this.tripNumber - 1
        ];
        this.validateData();
        if (!this.missingInfo) {
          this.showAlert = false;
          this.infoHaul.pcmiler = await this.getPcMiler();
          if (
            modesByDepartment.HHModes.includes(this.infoHaul?.tms_mode?.name) &&
            this.infoHaul?.tms_mode?.name === "FTL - Dry Team Drivers"
          )
            await this.getRateIqInformation();
          await this.getDatInformation(responseInfoHaul);
          this.visibleTable = true;
          if (
            responseInfoHaul?.status == 200 &&
            this.infoHaul?.tms_mode?.name === "Expedited"
          ) {
            this.infoHaul = this.$store.getters[
              "quotes/quote/showQuoteById"
            ].haul[this.tripNumber - 1];
            await this.calculateSpecialService();
            this.busy = false;
          }
        }
      } else {
        missingFieldsAlert("Please, select an Equipment Type!");
      }
      this.busy = false;
    },
    async getInfoPricingModel() {
      let response;
      if (modesByDepartment.FTLModes.includes(this.infoHaul?.tms_mode?.name)) {
        response = await this.$store.dispatch(
          "quotes/quote/getInfoFTLPricingModel",
          this.infoHaul.id
        );
      } else if (
        modesByDepartment.TCModes.includes(this.infoHaul?.tms_mode?.name)
      ) {
        response = await this.$store.dispatch(
          "quotes/quote/getInfoTCPricingModel",
          this.infoHaul.id
        );
      } else if (
        modesByDepartment.HHModes.includes(this.infoHaul?.tms_mode?.name)
      ) {
        response = await this.$store.dispatch(
          "quotes/quote/getInfoHHPricingModel",
          this.infoHaul.id
        );
      }
      if (response?.status === 200) {
        this.getPredictedCost(response?.data);
        this.activePricingAlert();
      }
    },
    async pricingModel() {
      let response;
      const payload = {
        pcmiler: this.infoHaul?.pcmiler,
        id: this.infoHaul.id
      };
      const { tms_mode } = this.infoHaul || {};
      const modeName = tms_mode?.name;
      const isFTLModes = modesByDepartment.FTLModes.includes(modeName);
      const isFTLFlatbed = modesByDepartment.FTLModes.filter(
        e => e === "Car Carrier" && e === "FTL - Dry"
      ).includes(modeName);
      const isTCModes =
        modesByDepartment.TCModes.includes(modeName) &&
        this.selectedEquipmentType === "REEFER";
      const isHHModes =
        modesByDepartment.HHModes.includes(modeName) &&
        this.selectedEquipmentType === "FLATBED";
      const isFlatbedFTL = () =>
        this.selectedEquipmentType === "FLATBED" && isFTLFlatbed;
      const isVanFTL = () =>
        this.selectedEquipmentType === "VAN" && !isFTLFlatbed;
      if (isFTLModes) {
        payload.modesQuoted = ["FTL", "PARTIAL"];
        if (isFlatbedFTL || isVanFTL) {
          response = await this.$store.dispatch(
            "quotes/quote/sendInfoFTLPricingModel",
            payload
          );
        }
      } else if (isTCModes) {
        response = await this.$store.dispatch(
          "quotes/quote/sendInfoTCPricingModel",
          payload
        );
      } else if (isHHModes) {
        payload.modesQuoted = ["FLATBED", "PARTIAL"];
        response = await this.$store.dispatch(
          "quotes/quote/sendInfoHHPricingModel",
          payload
        );
      }
      this.busy = false;
      if (response.status === 200) await this.getPredictedCost(response?.data);
      /* if (this.predictedCost === null) {
        await this.$store.dispatch(
          "quotes/quote/dataPricingSocket",
          this.infoHaul.id
        );
      } */
    },
    async getDatInformation(responseInfoHaul) {
      let info = {};
      info.haulId = this.infoHaul.id;
      info.city_origin = this.infoHaul.city_from;
      info.postalCode_origin = this.infoHaul.zip_from;
      info.country_origin = this.infoHaul.state_from;
      info.city_destination = this.infoHaul.city_to;
      info.postalCode_destination = this.infoHaul.zip_to;
      info.country_destination = this.infoHaul.state_to;
      info.equipment_type = this.selectedEquipmentType;
      let response = await this.$store.dispatch("carrierCost/getDat", info);
      if (response?.status == 200) {
        let tableDat = response.data.data;
        this.itemsTable = this.getTableDat(tableDat);
        if (responseInfoHaul?.status === 200) {
          this.infoHaul = this.$store.getters[
            "quotes/quote/showQuoteById"
          ].haul[this.tripNumber - 1];
          await this.pricingModel();
        }
      }
    },
    async getPcMiler() {
      let info = {};
      info.haul_id = this.infoHaul.id;
      info.city_to = this.infoHaul.city_to;
      info.state_to = this.infoHaul.state_to;
      info.zipCode_to = this.infoHaul.zip_to;
      info.country_to = "US";
      info.city_from = this.infoHaul.city_from;
      info.state_from = this.infoHaul.state_from;
      info.zipCode_from = this.infoHaul.zip_from;
      info.country_from = "US";
      let response = await this.$store.dispatch(
        "coordinatesMap/getCoordinatesMap",
        info
      );
      if (response?.status == 200) {
        return response.data;
      }
    },
    async getRateIqInformation() {
      let info = {};
      info.mode_id = this.infoHaul?.tms_mode?.id;
      info.haulId = this.infoHaul.id;
      info.city_to = this.infoHaul.city_to;
      info.state_to = this.infoHaul.state_to;
      info.zipCode_to = this.infoHaul.zip_to;
      info.country_to = "US";
      info.city_from = this.infoHaul.city_from;
      info.state_from = this.infoHaul.state_from;
      info.zipCode_from = this.infoHaul.zip_from;
      info.country_from = "US";
      let response = await this.$store.dispatch("carrierCost/getRateIq", info);
      if (response?.status == 200) {
        this.routeCalculated = response.data;
      }
    },
    validateData() {
      let fieldsHaul = {
        "city from": this.infoHaul.city_from,
        "city to": this.infoHaul.city_to,
        "zip from": this.infoHaul.zip_from,
        "zip to": this.infoHaul.zip_to,
        customer: this.infoHaul.customer_id,
        "linear feet": this.infoHaul.linear_feet,
        mode: this.infoHaul?.tms_mode?.id
      };
      let missingData = [];
      let alertMsg = "";
      let title = "";
      for (let field in fieldsHaul) {
        if (!fieldsHaul[field]) {
          missingData.push(field);
        }
      }
      if (missingData.length > 0) {
        this.missingInfo = true;
        if (missingData.length == 1) {
          title = "Missing Field";
          alertMsg =
            missingData[0] === "linear feet"
              ? "Please select a container and then calculate the linear feet"
              : missingData[0] + " is required";
        } else {
          title = "The next fields are required: \n\n";
          missingData.forEach(element => {
            alertMsg += element + " is required" + "\n";
          });
        }
        errorAlert(title, alertMsg);
      } else {
        this.missingInfo = false;
      }
    },

    onHidden() {
      this.$refs["button-calculate"].focus();
    },
    getTableDat(tableDat) {
      for (const row of tableDat) {
        for (const element in row) {
          if (
            element == "timeframe" ||
            element == "originType" ||
            element == "destinationType" ||
            element == "escalationType" ||
            element == "total"
          ) {
            row[element] = row[element].replace(/_/g, " ").toLowerCase();
          }
        }
      }
      return tableDat;
    },
    handlerCarrierCost() {
      let userAux = localStorage.getItem("charlie-username-otr");
      this.user = JSON.parse(userAux);
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      let allowedRoutes = ["queue", "myQueue", "failed"];
      if (!allowedRoutes.includes(this.$route.params.pathName)) {
        this.allowed = false;
      }
      if (
        this.currentDepartment.rol_name == "superuser" ||
        !this.allowed ||
        this.user[0].user.username !== this.assignedUser
      ) {
        document.getElementById(
          `carrier-cost` + this.tripNumber
        ).style.pointerEvents = "none";
      }
    },
    async calculateSpecialService() {
      this.busy = true;
      if (this.infoHaul?.pcmiler) {
        if (this.infoHaul?.tms_mode.name === "Expedited") {
          await this.calculateQuoteSpecialService();
        } else {
          await this.getPredictionSpecialService();
        }
      } else {
        missingFieldsAlert(
          "Please verify that the miles are already calculated."
        );
      }
      this.busy = false;
    },
    async getPredictionSpecialService() {
      this.busy = true;
      const info = {};
      info.miles = this.infoHaul.pcmiler.miles;
      info.origin_state = this.infoHaul.state_from;
      info.origin_zip_code = this.infoHaul.zip_from;
      info.destination_state = this.infoHaul.state_to;
      info.destination_zip_code = this.infoHaul.zip_to;
      await this.$store.dispatch(
        "specialServiceModel/getPredictionSpecialService",
        info
      );
      this.busy = false;
    },
    async calculateQuoteSpecialService() {
      this.busy = true;
      const info = {};
      info.haul_id = this.infoHaul.id;
      info.body = { ...this.infoHaul?.pcmiler };
      await this.$store.dispatch(
        "specialServiceModel/calculateQuoteSpecialService",
        info
      );
      this.busy = false;
    },
    async getSpecialServiceData() {
      if (this.infoHaul?.tms_mode?.name === "Expedited") {
        this.busy = true;
        const info = {};
        info.haul_id = this.infoHaul?.id;
        await this.$store.dispatch(
          "specialServiceModel/getSpecialServiceData",
          info
        );
        this.busy = false;
      }
    },
    async getPredictedCost(predictions) {
      this.minPricing = undefined;
      this.maxPricing = undefined;
      this.predictedCost = undefined;
      this.confidenceLevel = undefined;
      this.salePrice = undefined;
      this.networkRate = undefined;
      this.minPricing2 = undefined;
      this.maxPricing2 = undefined;
      this.predictedCost2 = undefined;
      this.confidenceLevel2 = undefined;
      this.salePrice2 = undefined;
      this.networkRate2 = undefined;
      if (predictions) {
        if (modesByDepartment?.FTLModes.includes(this.infoHaul.tms_mode.name)) {
          predictions.forEach(element =>
            this.assignValuesToVariables(element, element.source)
          );
        } else if (
          modesByDepartment?.HHModes.includes(this.infoHaul.tms_mode.name)
        ) {
          predictions.forEach(element => {
            this.assignValuesToVariables(element, element.source);
          });
        } else {
          this.assignValuesToVariables(predictions, predictions.source);
        }
      }
    },
    assignValuesToVariables(element, title) {
      const isPartial = title === "PARTIAL";
      const siffix = isPartial ? "" : 2;
      this[`predictedCost${siffix}`] = Math.round(element?.predict_cost);
      this[`minPricing${siffix}`] = Math.round(element?.min_predict_cost);
      this[`maxPricing${siffix}`] = Math.round(element?.max_predict_cost);
      this[`confidenceLevel${siffix}`] = Math.round(element?.confidence_level);
      this[`salePrice${siffix}`] = Math.round(element?.sale_price);
      this[`networkRate${siffix}`] = Math.round(element?.network_rate);
      if (isPartial && title) this.title1 = title;
      else if (!isPartial) this.title2 = title;
    },
    filterPricingUser() {
      let infoUser = JSON.parse(localStorage.getItem("charlie-username-otr"));
      const found = pricingEnabledUsers.pricingEnabledUsers.some(
        element => element.username === infoUser[0].user.username
      );
      this.showPredictedCost = found
        ? "carrier-cost__elements--data"
        : "carrier-cost__elements--cost-data";
    },
    activePricingAlert() {
      this.showAlert =
        (this.predictedCost === null &&
          this.minPricing === null &&
          this.maxPricing === null &&
          this.confidenceLevel === null) ||
        this.predictedCost?.message;
      this.predictedMsg =
        this.predictedCost === null
          ? "No available predictions for this lane (Distance less than 250 miles)."
          : this.predictedCost?.message;
    }
  }
};
</script>

<style lang="scss" scoped>
.carrier-cost {
  @include card;
  padding: 21px;
  height: 100%;
  hr {
    @include margin-card-hr;
  }
  &__header {
    @include flex-wrap(space-between);
    &--title {
      margin: 0px;
      align-self: center;
    }
  }
  &__calculate-function {
    display: flex;
    justify-content: center;
    align-self: center;
    flex-direction: row;
    width: 24rem;
    &--calculate-button {
      @include primary-button;
      margin-left: 0.5rem;
      display: flex;
      align-items: center;
    }
  }
  &__elements {
    @include flex-wrap(space-between);
    margin-left: 0.5rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    &--data {
      margin-top: 5px;
      width: 250px;
    }
    &--cost-data {
      margin-top: 5px;
      color: #ffffff;
    }
  }
  &__predicted {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  &__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    &--text {
      font-size: 14px;
      margin: 0;
    }
    &--splitter {
      padding-left: 1rem;
      border-left: 1px solid;
    }
  }
  &__table {
    @include card;
    width: 95%;
    display: inline-block;
    margin: 10px;
    &--title {
      margin: 0 0 10px 0;
      text-align: center;
    }
  }
}

.show-dat {
  display: flex;
  justify-content: start;
  margin-top: 10px;
  &__button {
    margin-top: 10px;
    @include secondary-button;
  }
}

@media (max-width: 767px) {
  .carrier-cost {
    margin-top: 15px;
    &__elements {
      display: grid;
      grid-template-columns: 1fr;
    }
    &__content {
      display: flex;
      flex-direction: column;
      margin: 0;
    }
  }
}
</style>
